module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"label":"不确定哪个尺码合适？{link}查看 AI 推荐的尺码！","label_link":"点击这里"}}')
  delete Component.options._Ctor
}
